export const CREDITORS_CONTAINER_TAG_NAME = 'creditors-container';
